import { useHead } from '@unhead/react';
import { RouterProvider } from 'react-router-dom';

import { useAppRouter } from './useAppRouter';

const Router = () => {
  const router = useAppRouter();

  useHead({ titleTemplate: (title) => (title ? `CAP - ${title}` : 'CAP') });

  return <RouterProvider router={router} />;
};

export default Router;
